import { ApiService } from '../../types/api';
import type { StockLocationsAPIResponse } from './types';

export interface StockLocationsApiContract {
  list(): Promise<StockLocationsAPIResponse[]>;
}

declare module '../../context/page-context' {
  interface Apis {
    stockLocations: StockLocationsApiContract;
  }
}

export class StockLocationsApi extends ApiService implements StockLocationsApiContract {
  public list(): Promise<StockLocationsAPIResponse[]> {
    return this.api.proxy<StockLocationsAPIResponse[]>({
      method: 'GET',
      path: '/v1/stock-locations',
    });
  }
}
